// extracted by mini-css-extract-plugin
module.exports = {"container":"kiosk-food_container__1Ftdw","top":"kiosk-food_top__2shDp","bottom":"kiosk-food_bottom__1Fsiz"};